import type { GoodCustomsInformation, PackingListRow } from "@RequestFormV2/sections/PackingList/types";

export const CONTAINER_HANDLING_UNIT = "container";

export type PackingListUnitDefaults = {
  m_unit?: string;
  w_unit?: string;
};

export function createEmptyPackingListRow(
  overrides: Partial<PackingListRow> = {},
  unitDefaults?: PackingListUnitDefaults,
): PackingListRow {
  return {
    length: null,
    width: null,
    height: null,
    units: null,
    weight_piece: null,
    stackable: false,
    crating_required: false,
    hazardous: false,
    temperature_control_required: false,
    temperature_control_value: "",
    is_dangerous_good: false,
    dangerous_good_value: "",
    un_number: "",
    additional_information: "",
    nmfc_class: "",
    m_unit: unitDefaults?.m_unit ?? "cm",
    w_unit: unitDefaults?.w_unit ?? "kg",
    ...overrides,
  };
}

export function createEmptyContainerRow(unitDefaults?: PackingListUnitDefaults): PackingListRow {
  return createEmptyPackingListRow(
    {
      handling_unit: CONTAINER_HANDLING_UNIT,
      container_type: "",
    },
    unitDefaults,
  );
}

export function createEmptyHandlingUnitRow(unitDefaults?: PackingListUnitDefaults): PackingListRow {
  return createEmptyPackingListRow(
    {
      handling_unit: "",
    },
    unitDefaults,
  );
}

export function createEmptyCommodityEntry(defaultCurrency = ""): GoodCustomsInformation {
  return createCommodityEntry({}, defaultCurrency);
}

export function createCommodityEntry(
  overrides: Partial<GoodCustomsInformation> = {},
  defaultCurrency = "",
): GoodCustomsInformation {
  return {
    commodity_key: crypto.randomUUID(),
    parent_assigned: false,
    hs_code: null,
    origin_country: null,
    value: null,
    currency_code: defaultCurrency,
    description: "",
    ...overrides,
  };
}
